
let count = 1000;

export default function GetUniqueId() {
    return "N" + (count++);
}